<template>
    <nav v-if="pagination.totalPages > 1" class="pagination" role="navigation" aria-label="pagination">
        <ul class="pagination-list">
            <li class="pagination-prev">
                <button class="pagination-previous" @click.prevent="changePage(pagination.pageIndex - 1)" v-bind:disabled="pagination.pageIndex <= 1 ? 'disabled' : false">
                    <span class="icon-angle-left"></span>
                    <span class="sr-only">Previous</span>
                </button>
            </li>

            <li class="pagination-page">
                <div class="pagination-dropdown-label" @click="togglePaginationDropdown()">
                    Showing
                    <span class="pagination-dropdown-pages">{{ pagination.pageIndex }} of {{ endPage }}</span>
                    <span class="icon-angle-down"></span>
                </div>

                <div class="pagination-dropdown" v-if="showDropdown">
                    <ul>
                        <li class="pagination-dropdown-item" v-bind:data-page="page" v-bind:class="isCurrentPage(page) ? 'active' : ''" @click="changePage(page)" v-for="page in pages">Page {{ page }}</li>
                    </ul>
                </div>
            </li>

            <li class="pagination-next">
                <button class="pagination-next" @click.prevent="changePage(pagination.pageIndex + 1)" v-bind:disabled="pagination.pageIndex >= pagination.totalPages ? 'disabled' : false">
                    <span class="icon-angle-right"></span>
                    <span class="sr-only">Next</span>
                </button>
            </li>
        </ul>
    </nav>
</template>

<script>
	import { mapState, mapActions, mapMutations } from 'vuex';

	export default {
		data: function () {
			return {
				pages: [],
				startPage: 0,
				endPage: 0,
				showDropdown: false
			}
		},
		computed: mapState({
			pagination: state => state.listing.pagination,
			specification: state => state.listing.specification,
		}),
		watch: {
			pagination: {
				handler: function (newProp, oldProp) {
					// after api call, regenerate pages
					this.createStartEndPages();
				},
				deep: true,
				immediate: true
			},
		},
		mounted() {
			this.createStartEndPages();
		},
		methods: {
			...mapMutations('listing', { updateSpecification: 'updateSpecification' }),
			createStartEndPages() {
				this.startPage = 1;
				this.endPage = this.pagination.totalPages;

				if (this.startPage <= 0) {
					// this.endPage -= this.startPage - 1;
					this.startPage = 1;
				}

				if (this.endPage > this.pagination.totalPages) {
					// this.endPage = this.pagination.totalPages;
				}

				this.setPages();
			},
            isCurrentPage(page) {
                return this.pagination.pageIndex === page;
            },
            changePage(page) {
				if (page > this.pagination.totalPages) {
					page = this.pagination.totalPages;
				}

				this.showDropdown = false;

                this.updateSpecification({ key: 'PageIndex', value: page - 1});
			},
			setPages() {
				let from = this.startPage;
				let to = this.endPage;
				this.pages = [];

				while (from <= to) {
					this.pages.push(from);
					from++;
				}
            },
            togglePaginationDropdown() {
				this.showDropdown = !this.showDropdown;
            }
        }
    }
</script>